import type { RaceSnapshot } from '../../shared/race';

export type Freshness = 'fresh' | 'stale' | 'unknown';
export const TELEMETRY_MAX_AGE_MS = 10_000;
export const INTERVAL_MAX_AGE_MS = 15_000;
export const WEATHER_MAX_AGE_MS = 180_000;

/** Pick the newest available source timestamp without branching on an adapter. */
export function latestSourceAt(...values: (string | null | undefined)[]) {
  const valid = values.flatMap(value => value && Number.isFinite(Date.parse(value)) ? [value] : []);
  return valid.sort((a, b) => Date.parse(b) - Date.parse(a))[0];
}

/** Compare channel timestamps with the displayed race time, never the viewer's wall clock. */
export function sourceFreshness(updatedAt: string | null | undefined, snapshot: Pick<RaceSnapshot, 'session' | 'atMs'>, maxAgeMs: number): Freshness {
  if (!updatedAt) return 'unknown';
  const sampleTime = Date.parse(updatedAt);
  const displayTime = Date.parse(snapshot.session.dateStart) + snapshot.atMs;
  if (!Number.isFinite(sampleTime) || !Number.isFinite(displayTime) || sampleTime > displayTime) return 'unknown';
  return displayTime - sampleTime > maxAgeMs ? 'stale' : 'fresh';
}

export function isRaceSession(name: string) {
  return /race|sprint|正赛|冲刺/i.test(name) && !/qual|shootout|排位/i.test(name);
}

export function recordedBestLap(laps: (number | null)[]) {
  const valid = laps.filter((lap): lap is number => lap !== null && Number.isFinite(lap) && lap > 0);
  return valid.length ? Math.min(...valid) : null;
}

export function bestLapDifference(lap: number | null, best: number | null) {
  if (lap === null || best === null || !Number.isFinite(lap) || !Number.isFinite(best) || lap <= 0 || best <= 0 || lap < best) return null;
  return lap - best;
}
